












































import { Component, Vue } from "vue-property-decorator";
import ItemData from "../model/ItemData";
@Component
export default class toolbar extends Vue {
  cateflag: boolean = false;
  showInput() {
    this.$store.commit("setTransItem", new ItemData(-1, 0));
  }
  doFliter(id: number) {
    if (id == -1) {
      return this.$store.state.actionHelper.demoList.filter((e: any) => {
        return e.archive === false;
      }).length;
    } else if (id == -2) {
      return this.$store.state.actionHelper.demoList.filter((e: any) => {
        return e.archive === true;
      }).length;
    } else {
      return this.$store.state.actionHelper.demoList.filter((e: any) => {
        return e.archive === false && e.categoryId === id;
      }).length;
    }
  }

  selectCate(id: number): void {
    this.cateflag = false;
    this.$store.commit("setFilterId", id);
  }
}
